import { apiRequest } from '@/api/core/client';

export interface ClickUpSettings {
  defaultListId: string | null;
}

export interface ClickUpList {
  id: string;
  name: string;
  folderId: string | null;
  folderName: string | null;
}

export interface ClickUpTask {
  id: string;
  name: string;
  url: string;
  status: string;
  listId: string;
  listName: string;
}

export interface CreateProductLineParams {
  listId: string;
  name: string;
  description?: string;
  dueDate?: string;
  /** Source email to link to tasks created from this product line */
  sourceEmail?: {
    accountId: number;
    messageId: number;
  };
}

/**
 * Trigger ClickUp initial sync
 */
export async function triggerClickUpSync() {
  return apiRequest<{ success: boolean; itemsProcessed: number; itemsTotal: number }>({
    method: 'POST',
    path: '/integrations/clickup/sync',
  });
}

/**
 * Get ClickUp sync status
 */
export async function getClickUpSyncStatus() {
  return apiRequest<{ syncState: any | null }>({
    method: 'GET',
    path: '/integrations/clickup/status',
  });
}

/**
 * Unlink ClickUp integration from a task
 */
export async function unlinkClickUpIntegration(taskId: string) {
  return apiRequest<{ task: any }>({
    method: 'DELETE',
    path: `/integrations/clickup/tasks/${taskId}`,
  });
}

/**
 * Get ClickUp settings
 */
export async function getClickUpSettings() {
  return apiRequest<ClickUpSettings>({
    method: 'GET',
    path: '/integrations/clickup/settings',
  });
}

/**
 * Update ClickUp settings
 */
export async function updateClickUpSettings(settings: ClickUpSettings) {
  return apiRequest<ClickUpSettings>({
    method: 'PATCH',
    path: '/integrations/clickup/settings',
    body: settings,
  });
}

/**
 * Get ClickUp lists (manufacturers) from Products space
 */
export async function getClickUpLists() {
  return apiRequest<{ lists: ClickUpList[] }>({
    method: 'GET',
    path: '/integrations/clickup/lists',
  });
}

/**
 * Create a product line in ClickUp
 */
export async function createClickUpProductLine(params: CreateProductLineParams) {
  return apiRequest<{ task: ClickUpTask }>({
    method: 'POST',
    path: '/integrations/clickup/product-lines',
    body: params,
  });
}
